// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./locales"; // Імпортуємо словник

i18n
  .use(LanguageDetector) // Автоматично визначає мову браузера
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "ru", // Якщо мова не знайдена, використовувати російську
    interpolation: {
      escapeValue: false, // React вже захищає від XSS
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    }
  });

export default i18n;